import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Configuration } from '@adlatus-gui/domain/clearing';
import { BASE_PATH } from '../variables';
import { WatchedTicketCreateDto } from '../model/watchedTicketCreateDto';
import { WatchedTicketResponseDto } from '../model/watchedTicketResponseDto';

@Injectable({
  providedIn: 'root'
})
export class ClearingTicketWatchService {
  protected baseConfigPath = '';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) baseConfigPath: string,
    @Optional() configuration: Configuration
  ) {
    if (baseConfigPath) {
      this.baseConfigPath = baseConfigPath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.baseConfigPath =
        baseConfigPath || configuration.basePath || this.baseConfigPath;
    }
  }

  public watch(watchTicketCreate: WatchedTicketCreateDto) {
    return this.httpClient.request<WatchedTicketResponseDto>(
      'post',
      `${this.baseConfigPath}/troubleTicket/watch`,
      {
        body: watchTicketCreate
      }
    );
  }

  public unwatch(clearingTicketId: string) {
    return this.httpClient.request<WatchedTicketResponseDto>(
      'post',
      `${this.baseConfigPath}/troubleTicket/unwatch/${clearingTicketId}`
    );
  }

  public listWatchedTicketsByClearingTicketId(clearingTicketId: number) {
    return this.httpClient.request<Array<WatchedTicketResponseDto>>(
      'get',
      `${this.baseConfigPath}/troubleTicket/watch/${clearingTicketId}`
    );
  }
}
